import { defineMessages } from 'react-intl';

export default defineMessages({
  Title: {
    id: 'Results.Headers.Title',
    defaultMessage: 'Title',
  },
  Category: {
    id: 'Results.Headers.Category',
    defaultMessage: 'Category',
  },
  Location: {
    id: 'Results.Headers.Location',
    defaultMessage: 'Location',
  },
  DatePosted: {
    id: 'Results.Headers.DatePosted',
    defaultMessage: 'Date Posted',
  },
  Loading: {
    id: 'Results.Loading',
    defaultMessage: 'Loading',
  },
  NoResults: {
    id: 'Results.NoResults',
    defaultMessage: 'No results found',
  },
  NoResultsWithLinkToCN: {
    id: 'Results.NoResultsWithLinkToCN',
    defaultMessage:
      'Click <a class="tds-link" href="https://www.tesla.cn/careers/search/?site=CN">here</a> to apply for roles in Mainland China.',
  },
});
